import { ECompetitorsPromotionType } from '../../../../../../../../reducers/v2';

export const mapCompetitorTypeToTitle = (competitorType: ECompetitorsPromotionType): string => {
  switch (competitorType) {
    case ECompetitorsPromotionType.noPromotion:
      return 'Без продвижения';
    case ECompetitorsPromotionType.standard:
      return 'Стандарт';
    case ECompetitorsPromotionType.premium:
      return 'Премиум';
    case ECompetitorsPromotionType.top:
      return 'Топ';
    case ECompetitorsPromotionType.topWithBet:
      return 'Топ + Ставка';
    default:
      throw new Error(`Unknown competitor type: ${competitorType}`);
  }
};
